// const arrayToIdIndex =  <I extends { id: number | string }>(arr: readonly I[]) => {
//   return arr.reduce((dict, item) => {
//     dict[item.id] = item;
//     return dict;
//   }, {} as { [key in string | number]: I }) as { [key in typeof arr[number]['id']]: I };
// };

const arrayToIdIndex = <I extends { [key in K]: number | string }, K extends string = 'id'>(arr: readonly I[], key: K = 'id' as K) => {
  return arr.reduce((dict, item) => {
    dict[item[key]] = item;
    return dict;
  }, {} as { [key in string | number]: I }) as { [key in typeof arr[number][K]]: I };
};

export default arrayToIdIndex;

// const res = arrayToIdIndex([
//   { id: 1, title: 'one' },
//   { id: 2, title: 'two' },
//   { id: 3, title: 'three' },
// ] as const, 'title')
//
// const item = res['one'];
//
// const res2 = arrayToIdIndex([
//   { id: 1, title: 'one' },
//   { id: 2, title: 'two' },
//   { id: 3, title: 'three' },
// ] as const)
//
// const item2 = res2[1];
